/** User-facing workflow module names (nav, titles, deep links). */
export const WORKFLOW_MODULE_LABELS = {
  hub: 'Ask AI',
  library: 'Playbook',
  pulse: 'Terminal',
  radar: 'Scan',
  designer: 'Designer',
  simulate: 'Simulate',
};

export const DESIGNER_LINK_LABEL = 'Open in Designer';
export const DESIGNER_MODULE_LABEL = WORKFLOW_MODULE_LABELS.designer;
